import { client } from '@api/client';
import { URL } from '@api/urls';

import {
	IVesEventRawDataDTO,
	IVesEventsApiRes,
	IVesEventsDropdownsDataDTO,
	IVesEventsDTO,
	IVesEventsExportDTO,
} from '@interfaces/vesData/dto/vesEventsDTO';

const {
	vesEvents,
	vesEventsDropdownValues,
	vesExport,
} = URL;

export const getVesEvents = (dto: IVesEventsDTO): Promise<IVesEventsApiRes> => {
	return client.get(vesEvents, {
		params: dto,
	});
};

export const getVesEventsDropdownValues = (): Promise<IVesEventsDropdownsDataDTO> => {
	return client.get(vesEventsDropdownValues);
};

export const getVesEventRawDataById = (id: string): Promise<IVesEventRawDataDTO> => {
	return client.get(`${vesEvents}/${id}/message`);
};

export const exportVesEvents = (dto: IVesEventsExportDTO): Promise<void> => {
	return client.post(vesExport, dto);
};

